

import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { parameter } from 'src/app/interfaces/action';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { FilterParam } from 'src/app/interfaces/filter-param';
import { FormServices } from 'src/app/services/form.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

@Component({
    selector: 'custom-action-parameters',
    templateUrl: './custom-action-parameters.component.html',
    styleUrls: ['./custom-action-parameters.component.scss'],
    standalone: false
})

export class CustomActionParametersComponent implements OnInit {

  @Input('expressao') expressao:string;

  parameters:columnsDef[] = [];
  newMode:Boolean = false;
  entityName:string;
  showHeader: boolean = true;
  title:string = "Parâmetros de Execução";
  icon:string = "filter_alt";
  row = {};

  constructor(private fb:UntypedFormBuilder,@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>, private fs:FormServices,public cd: ChangeDetectorRef ) {
      this.formGroup = this.fb.group({})
      if ( data instanceof Array || typeof(data)=="string"){
          if ( data instanceof Array){
            this.expressao = JSON.stringify(data);
          }
          if ( typeof(data)=="string"){
            this.expressao = data;
          }
          
        }else{
          this.expressao = data.data;
          this.param = data.param;
          this.newMode = data.newMode;
          this.entityName = data.entityName;
          this.showHeader = data.showHeader;
          this.title = data.title;
          this.icon = data.icon;
          if ( data.row != null ){
            this.row = data.row;
          }else{
            this.row = {};      
          }
          
        }
   }

  formGroup:UntypedFormGroup;
  param:string = null;

  ngOnInit(): void {

      this.fs.cd = this.cd;  
      if ( this.newMode ){
        if ( this.param != null ){
        
          let match:parameter[]  = JSON.parse(this.param);
          
          for(var dataParam of match){
        
            var r:parameter = dataParam;
            var i:number = 1;
              
            var filterparam:parameter = r ;
            var dataType  = "";
            switch ( filterparam.parameterType.toUpperCase() ){
              case "S" :{  dataType = "VARCHAR"; break;}
              case "D" :{ dataType = "DATETIME"; break;}
              case "N" :{ dataType = "FLOAT"; break;}
              case "I" :{ dataType = "INT"; break;}
              case "L" :{ dataType = "SELECT"; break;}
              case "R" :{ dataType = "SEARCHREFERENCE"; break;}
              case "RT" :{ dataType = "RICHTEXT"; break;}
              default :{dataType = "VARCHAR"}
            }
  
            var validationError = ''
            // if ( dataType == "REFERENCE"){
            //
            // }
  
            if ( dataType =="SELECT"){
                let ob = {
                    'type':'select',
                    'options':filterparam.listOption
                }
                validationError = JSON.stringify(ob);
            }
  
            var columnDef:columnsDef = {
              DATATYPE:dataType,
              COLUMNDESC:filterparam.parameterDesc,
              COLUMNNAME: filterparam.parameterName,
              PLACEHOLDER:filterparam.parameterDesc,
              IDCOLUMN:i,
              ISIDENTITY:0,
              ISREQUIRED:1,
              VISIBLE:1,
              LINE:0,
              CELL:0,
              tab:'sem tab',
              REFERENCES:[{
                  CONSTRAINT_COLUMN_REF:filterparam.parameterName,
                  CONSTRAINT_NAME:filterparam.parameterName
              }],
              VALIDATIONERROR:validationError,
              }
  
              if ( dataType =="SEARCHREFERENCE"){
                
                columnDef.ISFK = 1;
                let ob={
                    RefName: filterparam.entityOrigem,
                    RefDesc: filterparam.entityDesc
                }
                columnDef.VALIDATIONERROR = JSON.stringify(ob);
              }
              this.parameters.push(columnDef);
  
              i++;  
              
              this.fs.refreshForm(this.formGroup,this.parameters,this.row,false);
          }
          
        }
      }else{
        if ( this.expressao != null ){
          
          var matchs:parameter[] = JSON.parse(this.expressao);
          
          var i:number = 1;
          matchs.forEach(r=>{
            
            var filterparam:parameter =  r;
            var dataType  = "";
            
            switch ( filterparam.parameterType.toUpperCase() ){
               case "S" :{  dataType = "VARCHAR"; break;}
               case "D" :{ dataType = "DATETIME"; break;}
               case "N" :{ dataType = "FLOAT"; break;}
               case "I" :{ dataType = "INT"; break;}
               case "L" :{ dataType = "SELECT"; break;}
               case "R" :{ dataType = "SEARCHREFERENCE"; break;}
               case "RT" :{ dataType = "RICHTEXT"; break;}
               default :{dataType = "VARCHAR"}
            }
   
            var validationError = ''
            
            if ( dataType =="SELECT"){
                let ob = {
                    'type':'select',
                    'options':filterparam.listOption
                }
                validationError = JSON.stringify(ob);
            }
  
            var columnDef:columnsDef = {
               DATATYPE:dataType,
               COLUMNDESC:filterparam.parameterDesc,
               COLUMNNAME: filterparam.parameterName,
               PLACEHOLDER:filterparam.parameterDesc,
               IDCOLUMN:i,
               ISIDENTITY:0,
               ISREQUIRED:1,
               VISIBLE:1,
               LINE:0,
               CELL:0,
               tab:'sem tab',
               REFERENCES:[{
                  CONSTRAINT_COLUMN_REF:filterparam.parameterName,
                  CONSTRAINT_NAME:filterparam.parameterName
               }],
               VALIDATIONERROR:validationError,
              }
  
              if ( dataType =="SEARCHREFERENCE"){
                
                columnDef.ISFK = 1;
                let ob={
                     RefName: filterparam.entityOrigem,
                     RefDesc: filterparam.entityDesc
                }
                columnDef.VALIDATIONERROR = JSON.stringify(ob);
              }
              
              this.parameters.push(columnDef);
  
              i++;  
          });
          
          this.fs.refreshForm(this.formGroup,this.parameters,this.row,false);
          
        }
     
      }
      
  }

  
  ngOnDestroy(){
    this.cd.detach(); 
  }

  ngAfterViewInit(){

  }

  cancelar(){
    this.dialogRef.close();
  }

  ok(){
    if ( this.formGroup.valid ){

      let formObj = this.formGroup.getRawValue(); // {name: '', description: ''}

      let serializedForm = JSON.stringify(formObj);
      
      this.dialogRef.close(serializedForm);
    }
    
  }


  
}
